import React from "react";
import "./styles.css";
import { getStatLabel } from "../../../Library/helpers";

const StatsCard = ({ title, value, format, round }) => {
  return (
    <div className="sc-card">
      <div className="sc-title-container">
        <span>{title}</span>
        <hr />
      </div>
      <div className="sc-data">
        <span className="sc-data-value">
          {getStatLabel(value || 0, format, 2, 1, round)}
        </span>
      </div>
    </div>
  );
};

export default StatsCard;
